import { ResourceOptions } from 'react-admin';
import { FaCoins } from 'react-icons/fa';
import { Resources } from '../../resource';

import './dataProvider';

export { default as list } from './List';

export const name = Resources.coinImages;
export const icon = FaCoins;
export const options: ResourceOptions = {
  label: 'resource.coinImages',
};
